export const common = {
  nav: {
    home: 'Home',
    products: 'Products',
    electricFireplaces: 'Electric Fireplaces',
    wallFireplaces: 'Freestanding Fireplaces',
    builtInFireplaces: 'Built-in Fireplaces',
    threeSidedFireplaces: '3-Sided Fireplaces',
    panoramaFireplaces: 'Panorama Fireplaces',
    waterVaporFireplaces: 'Water Vapor Fireplaces',
    accessories: 'Accessories',
    inspiration: 'Inspiration',
    becomeDealer: 'Become Dealer',
    about: 'About Dutch Fires',
    support: 'Support',
    contact: 'Contact',
    categories: {
      wallFireplaces: 'Freestanding Fireplaces',
      builtIn: 'Built-in Fireplaces',
      threeSided: '3-Sided Fireplaces',
      panorama: 'Panorama Fireplaces',
      waterVapor: 'Water Vapor Fireplaces',
      accessories: 'Accessories'
    }
  },
  hero: {
    badge: 'B2B WHOLESALE',
    title: 'Premium Electric Fireplaces',
    titleSecond: 'For Professionals',
    subtitle: 'Exclusively available through our official European dealer network',
    ctaPrimary: 'Become a Dealer',
    ctaSecondary: 'View Products',
    stats: {
      dealers: 'Dealers',
      countries: 'Countries',
      certified: 'CE Certified'
    }
  },
  usps: {
    europeanBrand: {
      title: 'European Brand',
      description: 'Premium quality from Europe'
    },
    fastDelivery: {
      title: 'Fast Delivery',
      description: 'Reliable logistics across Europe'
    },
    highMargins: {
      title: 'High Margins',
      description: 'Attractive wholesale prices'
    },
    fullSupport: {
      title: 'Full Support',
      description: 'Marketing & technical support'
    }
  },
  categories: {
    title: 'Our Product Categories',
    wallFireplaces: 'Wall Fireplaces',
    freestandingFireplaces: 'Freestanding Fireplaces',
    builtIn: 'Built-in Fireplaces',
    threeSided: '3-Sided Fireplaces',
    panorama: 'Panorama Fireplaces',
    waterVapor: 'Water Vapor Fireplaces',
    accessories: 'Accessories',
    models: 'Models',
    viewProducts: 'View products',
    showAll: 'Show all products',
    clearFilter: 'Clear filter'
  },
  whyDutchFire: {
    label: 'WHY DUTCH FIRES',
    title: 'Your Partner in Premium Fireplace Solutions',
    subtitle: 'We support dealers with more than just products',
    wholesalePrices: {
      title: 'Wholesale Prices',
      description: 'Benefit from attractive margins and competitive prices for your business.',
      benefits: ['Tiered pricing structure', 'Volume discounts available', 'Transparent conditions']
    },
    marketingSupport: {
      title: 'Marketing Support',
      description: 'Comprehensive marketing materials and support for your sales activities.',
      benefits: ['Professional product photos', 'Marketing materials', 'Social media content']
    },
    technicalTraining: {
      title: 'Technical Training',
      description: 'Regular training and technical support for you and your team.',
      benefits: ['Online training', 'Product demonstrations', '24/7 technical support']
    }
  },
  inspiration: {
    label: 'INSPIRATION',
    title: 'Dutch Fires in Action',
    subtitle: 'Discover how our dealers integrate Dutch Fires into their projects',
    viewProject: 'View project',
    viewPossibilities: 'Discover possibilities',
    cta: 'Become a Dealer – Get Access to All Projects',
    viewAll: 'View All Projects',
    projects: {
      luxuryPenthouse: 'Luxury Penthouse',
      hotelLobby: 'Hotel Lobby',
      modernOffice: 'Modern Office',
      restaurantAmbiance: 'Restaurant Ambiance',
      residentialVilla: 'Residential Villa',
      showroom: 'Showroom'
    }
  },
  inspirationPage: {
    categories: {
      all: 'All Projects',
      residential: 'Residential',
      hospitality: 'Hospitality',
      commercial: 'Commercial'
    },
    cta: {
      title: 'Want Dutch Fires in your projects?',
      description: 'Become an official dealer and get access to exclusive project support, marketing materials and technical guidance for your installations.',
      button: 'Become a Dealer Now'
    }
  },
  dealerBenefits: {
    title: 'Join 500+ Successful Dealers',
    intro: 'Become part of our growing network of professional partners across Europe and benefit from exclusive advantages.',
    benefit1: {
      title: 'Exclusive Territory Rights',
      description: 'Secure your territory and minimize competition in your region.'
    },
    benefit2: {
      title: 'Comprehensive Product Training',
      description: 'Regular training on products, installation, and sales techniques.'
    },
    benefit3: {
      title: 'Marketing & Sales Support',
      description: 'Professional materials and campaigns to support your business.'
    },
    benefit4: {
      title: 'Technical Support',
      description: 'Direct access to our expert team for all technical questions.'
    },
    benefit5: {
      title: 'Flexible Delivery Options',
      description: 'Dropshipping, inventory, or project delivery – you choose.'
    },
    stats: {
      dealers: 'Active Dealers',
      countries: 'Countries',
      satisfaction: 'Satisfaction'
    },
    cta: 'Start Your Application'
  },
  dealerProcess: {
    badge: 'SIMPLE PROCESS',
    title: 'Become an Official Dealer in 3 Steps',
    step1: {
      title: 'Register',
      description: 'Fill out the online form with your business details',
      time: '2 Minutes'
    },
    step2: {
      title: 'Verification',
      description: 'We review your information and contact you personally',
      time: '1-2 Days'
    },
    step3: {
      title: 'Activation',
      description: 'Get access to the dealer portal and start',
      time: 'Immediately'
    },
    reassurance: 'No obligations • Free registration • Personal contact',
    cta: 'Fill Out Registration Form'
  },
  testimonials: {
    label: 'WHAT DEALERS SAY',
    title: 'Trusted by Professionals',
    dealerSince: 'Dealer since'
  },
  productShowcase: {
    title: 'Discover Our Collection',
    subtitle: 'All products available through our dealer portal',
    moreInfo: 'More information',
    viewAll: 'View All Products',
    productsFound: 'products found',
    noProducts: 'No products found in this category'
  },
  resources: {
    downloads: {
      title: 'Dealer Resources',
      catalog: 'Product Catalog 2025',
      technicalSpecs: 'Technical Specifications',
      installationGuide: 'Installation Guide',
      marketingMaterials: 'Marketing Materials'
    },
    support: {
      title: 'We\'re Happy to Help',
      contactText: 'Contact us for dealer support',
      email: 'Email Support',
      emailResponse: 'Response within 24h'
    }
  },
  footer: {
    tagline: 'Premium B2B Fireplace Solutions',
    newsletter: {
      placeholder: 'Your business email address',
      disclaimer: 'Business customers only'
    },
    products: 'Products',
    information: 'Information',
    contact: 'Contact',
    copyright: '© 2025 Dutch Fires',
    businessOnly: 'Business customers only',
    legal: {
      imprint: 'Imprint',
      privacy: 'Privacy',
      terms: 'Terms',
      cookies: 'Cookies'
    }
  },
  common: {
    learnMore: 'Learn more',
    contactUs: 'Contact us'
  },
  cookies: {
    title: 'Cookie Settings',
    description: 'We use cookies to enhance your experience and analyze our website. You can adjust your settings at any time.',
    settings: 'Settings',
    necessaryOnly: 'Necessary only',
    acceptAll: 'Accept all',
    settingsTitle: 'Manage Cookie Settings',
    savePreferences: 'Save preferences',
    alwaysOn: 'Always on',
    necessary: {
      title: 'Necessary Cookies',
      description: 'These cookies are required for basic website functionality and cannot be disabled.'
    },
    analytics: {
      title: 'Analytics Cookies',
      description: 'These cookies help us understand how visitors interact with our website.'
    },
    marketing: {
      title: 'Marketing Cookies',
      description: 'These cookies are used to make advertising more relevant to you.'
    }
  },
  productCTA: {
    b2bOnly: 'B2B Only',
    dealerOnly: 'Dealers Only',
    title: 'Interested in this product?',
    titleWithProduct: 'Interested in {{product}}?',
    description: 'Become an official Dutch Fires dealer and get access to wholesale prices, exclusive conditions, and full support.',
    interestedInProduct: 'Interested in {{product}}? Become a dealer for prices and orders.',
    interestedGeneral: 'Interested in our products? Become a dealer for prices and orders.',
    inlineTitle: 'Prices only available for registered dealers',
    benefit1: 'Access to wholesale prices',
    benefit2: 'Exclusive dealer conditions',
    benefit3: 'Personal support',
    becomeDealer: 'Become a Dealer',
    ctaButton: 'Become a Dealer Now',
    disclaimer: 'Only for businesses with valid registration',
    viewDetails: 'View Details'
  }
};